import React, { useState } from "react";
import { Dropdown } from "react-bootstrap";
import { ManagementDropdown } from "../../general/ManagementDropdown/ManagementDropdown";
import { ConfirmationModal } from "../../general/ConfirmationModal";
import { useRemoveReceiptEmail } from "../../../api/user.api";

interface ReceiptEmailDropdownProps {
    email: string;
}

export const ReceiptEmailDropdown: React.FC<ReceiptEmailDropdownProps> = ({
    email,
}) => {
    const [showRemovalConfirmation, setShowRemovalConfirmation] =
        useState<boolean>(false);

    const removeReceiptEmail = useRemoveReceiptEmail();

    return (
        <>
            <ManagementDropdown id={`receipt-email-dropdown-${email}`}>
                <Dropdown.Item
                    onClick={() => setShowRemovalConfirmation(true)}
                    className="text-danger"
                >
                    Remove email
                </Dropdown.Item>
            </ManagementDropdown>

            <ConfirmationModal
                show={showRemovalConfirmation}
                onHide={() => setShowRemovalConfirmation(false)}
                question={
                    <>
                        Receipts from <strong>{email}</strong> will no longer be
                        accepted. Are you sure?
                    </>
                }
                onConfirm={() => removeReceiptEmail.mutateAsync(email)}
                onReject={() => setShowRemovalConfirmation(false)}
            />
        </>
    );
};
